<template>
  <div class="form-group share-link-section">
    <label class="form-label">Share Link</label>

    <div v-if="!value">
      <b-button
        type="is-primary"
        size="is-small"
        icon-left="link-plus"
        :loading="isCreating"
        @click="createLink"
      >
        Create link
      </b-button>
    </div>

    <div v-else class="share-link-display">
      <b-tooltip
        :label="tooltipLabel"
        position="is-top"
        type="is-dark"
      >
        <span class="share-link-url" @click="copyLink">
          <b-icon icon="link" size="is-small" />
          {{ value }}
        </span>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { copyToClipboard } from '@/helpers/clipboard'
import { createShareLink } from '@/services/chottulink'

export default {
  name: 'ShareLink',
  props: {
    value: {
      type: String,
      default: '',
    },
    selectedPath: {
      type: String,
      required: true,
    },
    destinationUrl: {
      type: String,
      required: true,
    },
    linkName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isCreating: false,
      tooltipLabel: 'Click to copy',
    }
  },
  methods: {
    async createLink() {
      this.isCreating = true
      try {
        const shortUrl = await createShareLink({
          selectedPath: this.selectedPath,
          destinationUrl: this.destinationUrl,
          linkName: this.linkName,
        })
        this.$emit('input', shortUrl)
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Share link created!',
        })
      } catch (error) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: `Failed to create share link: ${error.message}`,
        })
      } finally {
        this.isCreating = false
      }
    },
    async copyLink() {
      await copyToClipboard(this.value)
      this.tooltipLabel = 'Copied!'
      setTimeout(() => {
        this.tooltipLabel = 'Click to copy'
      }, 2000)
    },
  },
}
</script>

<style scoped>
.share-link-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-light);
}

.share-link-url {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--feeds-green-light);
  color: var(--feeds-green);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
  word-break: break-all;
}

.share-link-url:hover {
  background: #ccebe7;
}
</style>
